<template>
  <div class="page page-full clients-page">
    <div class="page-header with-actions">
      <h1>Clients</h1>
      <div class="actions">
        <b-btn v-if="isAdmin" @click="toClientNotifications" variant="success" class="mr-3">Client Notifications</b-btn>
        <b-btn v-if="isAdmin" @click="toClientFeatures" variant="success" class="mr-3">Client Features</b-btn>
        <b-btn @click="createClient" variant="success">Add New Client Admin</b-btn>
      </div>
    </div>
    <dt-datatable ref="clientsList" :id="tableId" url="/client/client-list" :columns="columns" :dt-options="dtOptions">
      <template #actions="{ data: client }">
        <div class="td-links-wrap">
          <a class="btn btn-link p-0 text-success" @click="editClient(client)">Edit</a>
        </div>
      </template>
    </dt-datatable>
    <create-edit-client-admin-modal ref="createEditClientAdminModal" @success="clientSaved"></create-edit-client-admin-modal>
  </div>
</template>

<script>
  import CreateEditClientAdminModal from './create-edit-client-admin-modal';

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('client');

  export default {
    components: {
      CreateEditClientAdminModal
    },

    data() {
      let columns = [
        "Id",
        "Name",
        { name: "OwnerFirstName", title: "Main POC First Name" },
        { name: "OwnerLastName", title: "Main POC Last Name" },
        { name: "OwnerEmail", title: "Main POC Email" },
        { name: "Status", }
      ];

      if (this.$auth.isInRole("Admin"))
        columns.push({ name: 'Actions', data: false });

      return {
        tableId: `clients-list-id${this.$auth.id}`,
        dtOptions: {},
        columns: columns
      };
    },

    computed: {
      ...mapState(['client']),

      isAdmin() {
        return this.$auth.isInRole("Admin");
      }
    },

    methods: {
      editClient(data) {
         this.$refs.createEditClientAdminModal.show(data.id)
      },

      createClient() {
        this.$refs.createEditClientAdminModal.show();
      },

      clientSaved() {
        this.redrawTable();

        this.$root.successToast('Client admin saved!');
      },

      toClientFeatures() {
        this.$router.push({ path: "/client-features" });
      },

      toClientNotifications() {
        this.$router.push({ path: "/client-notifications" });
      },

      redrawTable() {
        this.$refs.clientsList.draw();
      }
    }
  }

</script>